<template>
  <!-- 度量衡组建 -->
  <div class="measure-wrap">
    <el-select
      v-model="pageFormData.measureInfo.templateId"
      style="width: 60px;margin-left: -2px;"
      placeholder="请选择规则"
      @change="hanldeTemplateChanged"
    >
      <template v-for="(item, index) in measureTemplates">
        <el-option :key="index" :label="formatTemplateLabel(item, index)" :value="item.templateId" />
      </template>
    </el-select>
    <template v-for="(item, index) in pageFormData.measureInfo.values">
      <div :key="index" class="field-item">
        <template v-if="item.prefix">
          <span>{{ item.prefix }}</span>
        </template>
        <template v-if="(item.inputType === 'input' && item.validateRule.dataType === 'float')">
          <el-input-digit
            :key="index"
            v-model.number="item.value"
            :precision="item.validateRule.precision"
            :max="item.validateRule.max"
            :min="item.validateRule.min"
            style="width: 80px;margin: 0 2px;"
            @change="handleValueChange"
          >
          </el-input-digit>
        </template>
        <template v-else-if="(item.inputType === 'input')">
          <el-input
            :key="index"
            v-model.number="item.value"
            style="width: 80px;margin: 0 2px;"
            @blur="handleValueChange"
          />
        </template>
        <div v-if="item.units && item.units.length > 0" class="suffix-wrap">
          <el-select
            v-model="item.unitId"
            style="width: 60px;margin-left: -2px;"
            @change="(val) => hanldeUnitChanged(val, item)"
          >
            <template v-for="(item, index) in (item.units || [])">
              <el-option :key="index" :label="item.unitName" :value="item.unitId" />
            </template>
          </el-select>
        </div>
        <template v-if="item.suffix">
          <span style="margin:0 4px;">{{ item.suffix }}</span>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import { fomatMeasureInfoItemValue } from './service.js';
import { cloneDeep } from 'lodash';
export default {
  props: {
    formData: {
      type: Object,
      default: {}
    },
    measureTemplates: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  watch: {
    formData: {
      handler(newVal) {
      },
      immediate: true
    }
  },
  computed: {
    firstData() {
      const { values } = this.formData;
      return values[0]
    },
    secondData() {
      const { values } = this.formData;
      return values[1]
    },
    pageFormData() {
      return this.formData.fxgExtra;
    }
  },
  methods: {
    formatTemplateLabel(template = {}, index) {
      const { valueModules = [] } = template;
      if (valueModules.length === 3) {
        return '单品'
      } else if (valueModules.length === 6) {
        return '两类组合'
      } else if (valueModules.length === 9) {
        return '三类组合'
      } else{
        return `规则${index + 1}`
      }
    },
    hanldeTemplateChanged(val) {
      const matchTemplate = this.measureTemplates.find(item => {
        return item.templateId === val;
      });
      const { valueModules = [] } = matchTemplate;
      const measureValues = valueModules.map((item, index) => {
        return item;
      });
      this.pageFormData.measureInfo.values = cloneDeep(measureValues);
    },
    hanldeUnitChanged(val, valueItem) {
      const { units = [] } = valueItem;
      const matchUnit = units.find(item => {
        return item.unitId === val;
      })
      if (matchUnit) {
        valueItem.unitName = matchUnit.unitName;
      } else {
        valueItem.unitName = '';
      }
      this.handleValueChange();
    },
    handleValueChange() {
      const { values = [] } = this.pageFormData.measureInfo;
      this.formData.value = fomatMeasureInfoItemValue(values);
      this.formData.fxgExtra.valueId = null;
      this.$emit('change')
      // if (this.$parent.$options.componentName === 'ElFormItem') {
      //   this.$parent.$emit('el.form.change', this.formData.value);
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.measure-wrap{
  min-width: 160px;
  display: inline-block;
  ::v-deep input.el-input__inner{
    border-radius: 0;
  }
  ::v-deep .el-input-digit .suffix{
    right: 0;
  }
  .field-item{
    display: inline-block;
    margin-bottom: 4px;
  }
  .suffix-wrap{
    display: inline-block;
    ::v-deep .el-select .el-input__inner{
      border-left: none;
    }
  }
}
</style>
